export default __webpack_public_path__ + "static/media/puppygrass.e316350d.jpg";